import { useCallback, useState } from 'react';
import { useIsMounted } from 'src/hooks/useIsMounted';
import { ArtistAPI } from '@tacans/shared-marketplace-layer';

export const useFetchArtistCountries = () => {
    const [countries, setCountries] = useState<string[]>([]);
    const isMounted = useIsMounted();

    const fetchCountries = useCallback(async () => {
        try {
            const response = await ArtistAPI.fetchCountries();

            if (response?.data.responseMeta?.error?.code) {
                throw new Error(response?.data.responseMeta?.error?.code);
            }

            isMounted(() => {
                setCountries(response?.data?.countries ?? []);
            });
            return response?.data?.countries ?? [];
        } catch (error) {
            console.error('useFetchArtistCountries', error);
            return [];
        }
    }, [isMounted]);

    return { countries, fetchCountries };
};

export const useFetchArtistCountriesForForm = () => {
    const [countries, setCountries] = useState<string[]>([]);
    const isMounted = useIsMounted();

    const fetchCountries = useCallback(async () => {
        try {
            const response = await fetch('/countries.json');
            const data = await response.json();

            isMounted(() => {
                setCountries(data ?? []);
            });
            return data ?? [];
        } catch (error) {
            return [];
        }
    }, [isMounted]);

    return { countries, fetchCountries };
};
